import styled from 'styled-components';
import {Button} from 'global/styles/styles.js';

const S = {};

S.AccountBonus = styled.div`
    width: 100%;
`;

S.BonusFilters = styled.div`
    display: flex;
    flex-direction: column-reverse;
    margin-top: 0.4rem;
`;

S.BonusFiltersDates = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    & > div {
         margin-right: 10px;
         &:last-of-type {
             margin-right: 0;
         }
    }
`;

S.DateLabel = styled.div`
    display: flex;
    font-weight: 400;
    color: ${({theme:{$datepickerLabelColor}})=> $datepickerLabelColor};
    background-color: ${({theme:{$datepickerLabelBg}})=> $datepickerLabelBg};
    padding-left: 0.75rem;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 14px;
`;

S.DateIcon = styled.i`
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    height: 100%;
    width: 33px;
    font-size: 1.67rem;
    color: #565656;
    justify-content: center;
    align-items: center;
    pointer-events: none;
`;

S.FilterBtn = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 42px;
    flex: 1;
    background-color: #C62828;
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-decoration: none;
   
    &.active {
            background-color: #D32F2F;
            text-overflow: ellipsis;
           
           &:after {
            content: '';
            position: absolute;
            bottom:-17px;
            width:0;
            height:0;
            border-top: 10px solid #D32F2F;
            border-bottom:10px solid transparent;
            border-left:10px solid transparent;
            border-right:10px solid transparent;
           } 
    }
`;

S.Datepicker = styled.div`
   position: relative;
   display: flex;
   height: 42px;
   width: 100%;
   border: 1px solid rgba(0, 0, 0, 0.24);
   border-radius: 3px;

   &:first-child {
    margin-right: 10px;
   }

   input[type="date"] {
    -o-appearance: none;
    -ms-appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    flex: 1 1 0%;
    padding: 0;
    padding-left: 10px;
    background-color: ${({theme:{$datepickerInputBg}})=> $datepickerInputBg};
    border: none;
    border-radius: 0;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    color: ${({theme:{$datepickerInputColor}})=> $datepickerInputColor};
    outline: none;

    &::-webkit-calendar-picker-indicator {
        padding: 0;
        opacity: 0;
        margin: 0;
    }
   }
`;

S.BonusFiltersBtns = styled.div`
    display: flex;
    flex: 1;

    & > a {
        &:hover,
        &:link,
        &:visited,
        &:active {
            text-decoration: none;
        }
    }
`;

export default S;